import React from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../../Store/Slices/AuthSlice";
import {
  Home,
  ListTodo,
  MessageSquare,
  Settings,
  LogOut,
  Pencil,
  RefreshCcw,
  StoreIcon,
  Receipt,
  List,
  Smartphone,
  X
} from "lucide-react";
import logobingopay from "../Assest/Logo/logo_png_with_shreebalajee (1).png";

const Sidebar = ({ menuItems, isOpen, onClose }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const user = useSelector((state) => state.auth.employeeDetails);

  const handleNavigate = (view) => {
    if (view) navigate(`/${view}`);
    onClose?.(); // ✅ auto-close on mobile
  };

  return (
    <aside
      className={`
        fixed left-0 top-0 h-screen w-[280px]
       bg-gradient-to-br from-[#F2F4F8] via-[#E8ECF3] to-[#DDE5F1]
        backdrop-blur-xl text-white flex flex-col z-50
        transition-transform duration-300
       ${isOpen ? "translate-x-0" : "-translate-x-full"}
      `}
    >
      {/* Logo + Close */}
      <div className="flex items-center justify-between px-4 pt-3">
        <img
          src={logobingopay}
          alt="logo"
          className="w-44 h-28 object-contain"
        />

        <button
          onClick={onClose}
          className="p-2 rounded-lg hover:bg-black/10"
        >
          <X size={20} className="text-black" />
        </button>
      </div>

      {/* Menu */}
      <div className="flex-1 px-4 space-y-2 overflow-y-auto">
        {menuItems?.map((item, index) => (
          <button
            key={index}
            onClick={() => handleNavigate(item.view)}
            className="
              w-full flex items-center gap-4 px-4 py-3 rounded-xl
              text-sm text-black/80
              hover:bg-black/15 hover:text-black
              transition-all
            "
          >
            {index === 0 && <Home size={18} />}
            {index === 1 && <ListTodo size={18} />}
            {index === 2 && <MessageSquare size={18} />}
            {index === 3 && <Settings size={18} />}
            {index === 4 && <Settings size={18} />}
            {index === 5 && <Settings size={20} />}
            {index === 6 && <Pencil size={18} />}
            {index === 7 && <RefreshCcw size={18} />}
            {index === 8 && <StoreIcon size={18} />}
            {index === 9 && <Receipt size={18} />}
            {index === 10 && <List size={18} />}
            {index === 11 && <List size={18} />}
            {index === 12 && <List size={18} />}
            {index === 13 && <List size={18} />}
            {index === 14 && <List size={18} />}
            {index === 15 && <List size={18} />}
            {index === 16 && <List size={18} />}
            {index === 17 && <List size={18} />}
            {index === 18 && <List size={18} />}
            {index === 19 && <List size={19} />}
            {index === 20 && <List size={20} />}
            {index === 21 && <List size={21} />}
            {index === 22 && <List size={21} />}
            {index === 23 && <List size={21} />}
            {index === 24 && <List size={21} />}
            {index === 25 && <List size={21} />}
            {index === 26 && <List size={21} />}
            {index === 27 && <List size={21} />}
            {index === 28 && <List size={21} />}
            {index === 29 && <Smartphone size={18} />}
            {index === 30 && <List size={21} />}
            {index === 31 && <List size={21} />}
            <span>{item.title}</span>
          </button>
        ))}
      </div>

      {/* User + Logout */}
      <div className="px-4 py-3 border-t border-balck/20">
        <div className="flex items-center gap-3 mb-4">
          <div className="w-12 h-12 rounded-full bg-black/20 flex items-center justify-center">
            <span className="text-lg text-black font-semibold">
              {user?.username?.[0]?.toUpperCase() || "U"}
            </span>
          </div>
          <div className="text-sm">
            <div className="font-medium text-black truncate">{user?.username}</div>
            <div className="text-xs text-black truncate">{user?.email}</div>
          </div>
        </div>

        <button
          onClick={() => {
            dispatch(logout());
            navigate("/");
          }}
          className="
            w-full flex items-center gap-3 px-4 py-2.5 rounded-xl
            text-sm text-red-900
            hover:bg-black/15 hover:text-red-400
          "
        >
          <LogOut size={18} />
          Logout
        </button>
      </div>
    </aside>
  );
};

export default Sidebar;


